import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type PageBracketProps = {
  children: ReactNode;
  /** The inner (portfolio) bracket, drawn inside the goal bracket. */
  nested?: boolean;
};

/**
 * QL-117 — a repeated part of the flow, drawn as a bracket down the left edge. The outer
 * bracket is "for each goal"; the nested one, inside it, is "for each portfolio".
 */
export function PageBracket({ children, nested = false }: PageBracketProps) {
  return (
    <div
      className={cn("space-y-6 border-l-2 pl-4", nested ? "border-primary/30" : "border-border")}
    >
      {children}
    </div>
  );
}
